

import SplitPane from "react-split-pane";
import { useImperativeHandle, useRef, useState } from "react";
import AddMarqueeMessageTestOne from "./add-marquee_message_test_one/AddMarqueeMessageTestOne";
import MarqueeMessageTableTestOne from "./MarqueeMessageTableTestOne";
import { Button, Card, Dropdown, Form, OverlayTrigger, Tooltip, } from "react-bootstrap";
import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IconButton from "components/common/IconButton";
import TableHeaderDropdown from "components/common/TableHeaderDropdown";
function TableViewTestOne() {
    const gridRef = useRef();
    const [selectedItem, setSelectedItem] = useState(null);
    const [refreshList, setRefreshList] = useState(false);
    const [searchText, setSearchText] = useState("");

    const handleSave = () => {
        gridRef.current?.saveState();
    };
    const handleRestore = () => {
        gridRef.current?.restoreState();
    };
    const handleReset = () => {
        gridRef.current?.resetState();
    };

    return (
        <div >
            <Card style={{ height: `calc(100vh - 8rem)`, }}>
                {/* ---------- HEADER (FULL WIDTH) ---------- */}
                <Card.Header className="d-flex justify-content-between align-items-center border-bottom">
                    <BreadCrumbTable title="Shopenze" subTitle="Marquee Messages" />

                    <div className="d-flex align-items-center gap-2">
                        {/* SEARCH BOX */}
                        <Form className="position-relative">
                            <FontAwesomeIcon
                                icon="search"
                                className="position-absolute text-400 search-box-icon"
                                style={{
                                    left: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                }}
                            />

                            <Form.Control
                                type="search"
                                placeholder="Search..."
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                className="rounded-pill search-input"
                                style={{ paddingLeft: "30px" }}
                            />
                        </Form>

                        {/* NEW BUTTON */}
                        <OverlayTrigger
                            overlay={<Tooltip style={{ position: "fixed" }}>New</Tooltip>}
                        >
                            <IconButton
                                variant="falcon-default"
                                size="sm"
                                icon="plus"
                                onClick={() => setSelectedItem({})}
                            >
                                <span className="d-none d-sm-inline-block ms-1">New</span>
                            </IconButton>
                        </OverlayTrigger>

                        <TableHeaderDropdown>
                            <div className="py-2">
                                <Dropdown.Item
                                    onClick={handleSave}
                                    className="d-flex align-items-center gap-2 py-2"
                                >
                                    Save State
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={handleRestore}
                                    className="d-flex align-items-center gap-2 py-2"
                                >
                                    Restore State
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={handleReset}
                                    className="d-flex align-items-center gap-2 py-2"
                                >
                                    Reset State
                                </Dropdown.Item>
                            </div>
                        </TableHeaderDropdown>
                    </div>
                </Card.Header>
                <Card.Body className="p-0">
                    <div >
                        <SplitPane split="vertical" minSize={520} defaultSize="35%" maxSize={1100}>

                            {/* LEFT GRID PANEL */}
                            <div style={{ height: "100%", overflow: "auto", borderRight: "1px solid #dee2e6" }}>
                                <MarqueeMessageTableTestOne
                                    ref={gridRef}
                                    onSelect={setSelectedItem}
                                    refresh={refreshList}
                                    searchText={searchText}  // <-- NEW
                                />
                            </div>

                            {/* RIGHT FORM PANEL */}
                            <div style={{ height: "100%", overflow: "auto" }}>
                                {selectedItem && (
                                    <AddMarqueeMessageTestOne
                                        selected={selectedItem}
                                        setSelectedItem={setSelectedItem}
                                        onSuccess={() => {
                                            setRefreshList((p) => !p);
                                            setSelectedItem(null);
                                        }}
                                    />
                                )}
                            </div>
                        </SplitPane>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
}

export default TableViewTestOne;